import React from "react";
import UserForm from "./UserForm";
import PropTypes from "prop-types";

import { IntlProvider } from "react-intl";
import { translations, locale } from "../../util/i18n";

const EditUserModal = (props) => {
  return (
    <IntlProvider
      locale={window._FLAIM_LOCALE}
      key={window._FLAIM_LOCALE}
      messages={translations[window._FLAIM_LOCALE]}
    >
      <UserForm url={props.url} method={"PUT"} defaultValues={{ ...props.userDetails }}></UserForm>
    </IntlProvider>
  );
};

EditUserModal.propTypes = {
  url: PropTypes.string.isRequired,
  userDetails: PropTypes.shape({
    first_name: PropTypes.String,
    last_name: PropTypes.String,
    email: PropTypes.String,
  }),
};

export default EditUserModal;
